import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The `DateTime` scalar type represents time data, ISO-8601 encoded UTC date string. */
  DateTime: any;
};

export type Query = {
  __typename?: 'Query';
  /** Курс определенной валюты в банке */
  exchangeRate?: Maybe<ExchangeRate>;
  /** Все курсы по банку */
  exchangeRates?: Maybe<Array<ExchangeRate>>;
};


export type QueryExchangeRateArgs = {
  bank: BankEnum;
  currency: CurrencyEnum;
};


export type QueryExchangeRatesArgs = {
  bank: BankEnum;
};

/** Доступные банки */
export enum BankEnum {
  Atb = 'ATB',
  Cbr = 'CBR',
  Khanbank = 'KHANBANK',
  Maybank2U = 'MAYBANK2U',
  Mufg = 'MUFG',
  Primsotsbank = 'PRIMSOTSBANK',
  Sbi = 'SBI',
  Solid = 'SOLID'
}

/** Доступные валюты */
export enum CurrencyEnum {
  Aed = 'AED',
  Amd = 'AMD',
  Aud = 'AUD',
  Azn = 'AZN',
  Bdt = 'BDT',
  Bgn = 'BGN',
  Bhd = 'BHD',
  Bnd = 'BND',
  Bob = 'BOB',
  Brl = 'BRL',
  Byn = 'BYN',
  Cad = 'CAD',
  Chf = 'CHF',
  Cny = 'CNY',
  Cup = 'CUP',
  Czk = 'CZK',
  Dkk = 'DKK',
  Dzd = 'DZD',
  Egp = 'EGP',
  Etb = 'ETB',
  Eur = 'EUR',
  Gbp = 'GBP',
  Gel = 'GEL',
  Hkd = 'HKD',
  Huf = 'HUF',
  Idr = 'IDR',
  Inr = 'INR',
  Irr = 'IRR',
  Jpy = 'JPY',
  Kgs = 'KGS',
  Krw = 'KRW',
  Kwd = 'KWD',
  Kzt = 'KZT',
  Lkr = 'LKR',
  Mdl = 'MDL',
  Mmk = 'MMK',
  Mnt = 'MNT',
  Mxn = 'MXN',
  Myr = 'MYR',
  Ngn = 'NGN',
  Nok = 'NOK',
  Nzd = 'NZD',
  Omr = 'OMR',
  Pgk = 'PGK',
  Php = 'PHP',
  Pkr = 'PKR',
  Pln = 'PLN',
  Qar = 'QAR',
  Ron = 'RON',
  Rsd = 'RSD',
  Rub = 'RUB',
  Sar = 'SAR',
  Sek = 'SEK',
  Sgd = 'SGD',
  Thb = 'THB',
  Tjs = 'TJS',
  Tmt = 'TMT',
  Try = 'TRY',
  Uah = 'UAH',
  Usd = 'USD',
  Uzs = 'UZS',
  Vnd = 'VND',
  Xag = 'XAG',
  Xau = 'XAU',
  Xdr = 'XDR',
  Zar = 'ZAR'
}

/** Информация о курсе */
export type ExchangeRate = {
  __typename?: 'ExchangeRate';
  /** Информация о банке */
  bank?: Maybe<Bank>;
  /** Покупка */
  buy?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Int']>;
  /** Валюта */
  isoCode?: Maybe<CurrencyEnum>;
  /** Последнее время обновления */
  lastUpdate?: Maybe<Scalars['DateTime']>;
  /** Номинал */
  nominal?: Maybe<Scalars['Int']>;
  /** Продажа */
  sell?: Maybe<Scalars['Float']>;
};

/** Информация о банке */
export type Bank = {
  __typename?: 'Bank';
  /** Алиас банка */
  alias?: Maybe<BankEnum>;
  id?: Maybe<Scalars['Int']>;
  /** Логировать изменение курса */
  isLogEnabled?: Maybe<Scalars['Boolean']>;
  /** Валюта банка в которой делаются расчёты */
  isoCode?: Maybe<CurrencyEnum>;
  /** Название банка */
  name?: Maybe<Scalars['String']>;
};

export type ExchangeRateFieldsFragment = { __typename?: 'ExchangeRate', sell?: Maybe<number>, nominal?: Maybe<number> };

export type ExchangeRateQueryVariables = Exact<{ [key: string]: never; }>;


export type ExchangeRateQuery = { __typename?: 'Query', rubToJpy?: Maybe<{ __typename?: 'ExchangeRate', sell?: Maybe<number>, nominal?: Maybe<number> }>, jpyToUsd?: Maybe<{ __typename?: 'ExchangeRate', sell?: Maybe<number>, nominal?: Maybe<number> }>, jpyToEur?: Maybe<{ __typename?: 'ExchangeRate', sell?: Maybe<number>, nominal?: Maybe<number> }> };

export const ExchangeRateFieldsFragmentDoc = gql`
    fragment ExchangeRateFields on ExchangeRate {
  sell
  nominal
}
    `;
export const ExchangeRateDocument = gql`
    query exchangeRate {
  rubToJpy: exchangeRate(bank: CBR, currency: JPY) {
    ...ExchangeRateFields
  }
  jpyToUsd: exchangeRate(bank: MUFG, currency: USD) {
    ...ExchangeRateFields
  }
  jpyToEur: exchangeRate(bank: MUFG, currency: EUR) {
    ...ExchangeRateFields
  }
}
    ${ExchangeRateFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ExchangeRateGQL extends Apollo.Query<ExchangeRateQuery, ExchangeRateQueryVariables> {
    document = ExchangeRateDocument;
    client = 'exchange-rate';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {}
};
      export default result;
    